const overrides = {
  MuiTableSortLabel: {
    active: {
      color: "rgba(255,255,255,var(--tw-text-opacity)) !important",
    },
    root: {
      color: "rgba(255,255,255,var(--tw-text-opacity)) !important",
    },
    icon: {
      color: "rgba(255,255,255,var(--tw-text-opacity)) !important",
    },
  },
  MuiIconButton: {
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  },
};

export default overrides;
